
/**
 * Created by Marcus Zhao on 7/1/2022.
 * Description:
 * ContactListModel
 *
 * ------ maintenance history ------
 */

import { Subject } from 'rxjs';

export enum ContactListActionType {
    CHECK_ITEM = 'check_item'
}

/** Admin Page Feedback Subject */
export class ContactListActionFeedback {
    type: ContactListActionType;
    payload?: any;
}


export class ContactListSetting {
    feedbackSubject$?: Subject<any>;
}

